import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripePublishableKey() {
  return (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '').trim();
}

export function getCoursePaymentStripePromise() {
  if (!stripePromise) {
    const publishableKey = getStripePublishableKey();
    stripePromise = publishableKey
      ? loadStripe(publishableKey)
      : Promise.resolve(null);
  }

  return stripePromise;
}
